<div class="p-flex-col-md">
  @if (mapping && typeMapping) {
  <ng-container
    *ngTemplateOutlet="
      fieldRow ;
      context: {
        colId: 'idCol',
        colName: 'Document ID',
        types: ['long', 'text'],
        tooltip: 'Must be unique per row. Can be either integer or text values'
      }
    "
  ></ng-container>
  <ng-container
    *ngTemplateOutlet="
      fieldRow ;
      context: {
        colId: 'tagsCol',
        colName: 'Labels',
        types: ['labels'],
        tooltip: 'Deep learning training data requires a label column. Labels can be single-label or multi-label. For multi-label data, separate labels with a | or , so Pienso can recognize them correctly.'
      }
    "
  ></ng-container>
  <ng-container
    *ngTemplateOutlet="
      fieldRow ;
      context: {
        colId: 'dateCol',
        colName: 'Date',
        types: ['date'],
        tooltip: 'To enable time-series visualization in a Pienso Dashboard, assign the \u201cDate\u201d category to a valid date-type column.'
      }
    "
  ></ng-container>
  <ng-container
    *ngTemplateOutlet="fieldRow ; context: {colId: 'titleCol', colName: 'Title', types: ['all']}"
  ></ng-container>
  <ng-container
    *ngTemplateOutlet="fieldRow ; context: {colId: 'authorCol', colName: 'Author', types: ['all']}"
  ></ng-container>
  <ng-container
    *ngTemplateOutlet="fieldRow ; context: {colId: 'publisherCol', colName: 'Publisher', types: ['all']}"
  ></ng-container>

  <div class="p-flex p-flex-between p-flex-center-y">
    <div class="p-flex-row-xxs p-flex-center-y">
      <span class="p-text-desc">Group documents</span>
      @if (editable) {
      <p-tooltip-anchor
        tooltip="Use these controls if your rows represent sequential parts of a larger document, such as messages in a chat conversation."
      />
      }
    </div>
    @if (editable) {
    <p-toggle [ngModel]="showGroup" (ngModelChange)="setShowGroup($event)" />
    }
  </div>
  @if (showGroup) {
  <ng-container
    *ngTemplateOutlet="
      fieldRow ;
      context: {
        colId: 'groupCol',
        colName: 'Group ID',
        types: ['long', 'text'],
        tooltip: 'Must be unique per row. Can be either integer or text values.'
      }
    "
  ></ng-container>
  <ng-container
    *ngTemplateOutlet="
      fieldRow ;
      context: {
        colId: 'sequenceCol',
        colName: 'Sequence number',
        types: ['long'],
        tooltip: 'Assign to a column with integer values that order documents within a group.'
      }
    "
  ></ng-container>
  <div class="p-flex-col-xxs">
    <div class="p-flex-row-xxs p-flex-center-y">
      <span class="p-text-desc">Analyze trigger</span>
      @if (editable) {
      <p-tooltip-anchor
        tooltip="If you only want to analyze certain rows, select the column that identifies those rows."
      />
      }
    </div>
    @if (editable) {
    <p-select
      trackBy="id"
      placeholder="Select column"
      [options]="optionsFor(['all'])"
      [showClear]="true"
      [ngModel]="selectedOption('analyzeCol', ['all'])"
      (ngModelChange)="onOptionChange('analyzeCol', $event)"
    />
    } @else {
    <span class="p-text-body">{{ columnName('analyzeCol') }}</span>
    }
  </div>
  <div class="p-flex-col-xxs">
    <div class="p-flex-row-xxs p-flex-center-y">
      <span class="p-text-desc">Analyze filter</span>
      @if (editable) {
      <p-tooltip-anchor
        tooltip="Enter the value a row must have in the selected Analyze trigger column to be analyzed."
      />
      }
    </div>
    @if (editable) {
    <p-text-input
      [ngModel]="mapping['analyzeQuery']"
      (ngModelChange)="mappingChanged('analyzeQuery', $event)"
      [disabled]="!mapping.analyzeCol?.trim()"
    />
    } @else {
    <span class="p-text-body">{{ mapping['analyzeQuery'] }}</span>
    }
  </div>
  } }
</div>

<ng-template #fieldRow let-colId="colId" let-colName="colName" let-types="types" let-tooltip="tooltip">
  @if (mapping && typeMapping && (editable || !!getMapping(colId))) {
  <div class="p-flex-col-xxs">
    <div class="p-flex-row-xxs p-flex-center-y">
      <span class="p-text-desc">{{ colName }}</span>
      @if (editable && tooltip) {
      <p-tooltip-anchor [tooltip]="tooltip" />
      }
    </div>
    @if (editable) {
    <p-select
      trackBy="id"
      placeholder="Select column"
      [options]="optionsFor(types)"
      [showClear]="true"
      [disabled]="!optionsFor(types).length"
      [ngModel]="selectedOption(colId, types)"
      (ngModelChange)="onOptionChange(colId, $event)"
    />
    } @else {
    <span class="p-text-body">{{ columnName(colId) }}</span>
    }
  </div>
  }
</ng-template>
